const getDefaultBonusPeriod = (
  bonusPeriods: BonusTypes.BonusPeriod[],
): BonusTypes.BonusPeriod | undefined => {
  // Prefer live/closed periods in priority order — archived periods are never
  // selected by default while any non-archived period exists.
  const firstPendingSignOff = bonusPeriods.find(
    (p) => p.status === 'pending sign off',
  );
  if (firstPendingSignOff) {
    return firstPendingSignOff;
  }

  const firstInReview = bonusPeriods.find((p) => p.status === 'in review');
  if (firstInReview) {
    return firstInReview;
  }

  const firstActive = bonusPeriods.find((p) => p.status === 'active');
  if (firstActive) {
    return firstActive;
  }

  const firstClosed = bonusPeriods.find((p) => p.status === 'closed');
  if (firstClosed) {
    return firstClosed;
  }

  // No non-archived period exists (every period is archived). Fall back to the
  // most recent period — bonusPeriods arrive sorted ascending by startDate, so
  // that's the last one.
  if (bonusPeriods.length > 0) {
    return bonusPeriods[bonusPeriods.length - 1];
  }

  return undefined;
};

export default getDefaultBonusPeriod;
